<template>
    <div class="course-item-vertical__details">
        <span class="course-item-vertical__categories">
            <span class="course-item-vertical__label" v-html="$t('General.categories')"></span>
            <template v-for="(category, index) in courseCategories">
                <span
                    class="course-item-vertical__categories-names"
                    :key="course.id + 'course-category' + index"
                >
                    <span class="course-item-vertical__category-name">{{ category }}</span>
                    <template v-if="index < courseCategories.length - 1">, </template>
                </span>
            </template>
        </span>
        <template v-if="itemType === 'course'">
            <span class="course-item-vertical__level">
                <span class="course-item-vertical__label" v-html="$t('General.level')"></span>
                <span class="course-item-vertical__level-number" v-html="$t(`Select.skill_level_${course.level}`)"></span>
            </span>
        </template>
        <template v-if="itemType === 'collection' || itemType === 'learningpath'">
            <span class="course-item-vertical__level">
                    <span class="course-item-vertical__label" v-html="$t('General.level')"></span>
                    <template v-for="(level, index) in course.levels" >
                        <span :key="index" class="course-item-vertical__level-number" v-html="$t(`Select.skill_level_${level}`)"></span>
                        <span :key="index" v-if="index !== course.levels.length - 1">,</span>
                    </template>
                </span>
        </template>
        <template v-if="shouldMinimizeCertificates && course.certifiedBy.length > 0">
            <span class="course-item-vertical__label" v-html="$t('General.certificates')"></span>
            <span>...</span>
            <span class="icon-info-solid" @mouseover="showMinimizedCertificates" @mouseleave="hideMinimizedCertificates"></span>

            <span class="course-item-vertical__all-badges" v-if="showCertificates">
                <span class="course-item-vertical__label"><span v-html="$t('General.certificates')"></span></span>
                <span class="course-item-vertical__minimized-badges" v-if="shouldShowCertificates">
                    <TotemCertificationBadge
                    v-for="(cert, index) in course.certifiedBy"
                    :name="cert.label"
                    size="small"
                    :key="course.id + 'certs-index' + index"
                    />
                </span>
            </span>
        </template>
        <template v-else>
            <span class="course-item-vertical__badges" v-if="shouldShowCertificates">
                <TotemCertificationBadge
                v-for="(cert, index) in course.certifiedBy"
                :name="cert.label"
                size="small"
                :key="course.id + 'certs-index' + index"
                />
            </span>
        </template>
        <span v-if="course.isTestAvailable" class="course-item-vertical__coursetest">
            <span class="icon-file-check"></span>
            <span v-html="$t('General.has_coursetest')"></span>
        </span>
    </div>
</template>

<script>
    import CourseItemHelper from 'components/shared/global-courses-items/helper/course-item-helper'

    export default {
        mixins: [ CourseItemHelper ],
        props: {
            course: {
                type: Object,
                required: true
            },
            itemType: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                showCertificates: false
            }
        },
        computed: {
            shouldShowCertificates () {
                return this.$totemLang !== 'se'
            },
            shouldMinimizeCertificates () {
                return this.$totemLang === 'no'
            },
            courseCategories () {
                return this.course.categoriesWithAncestors.map(
                    categoryWithAncestors => categoryWithAncestors.map(
                        ({ label }) => label
                    ).join(' > ')
                )
            }
        },
        methods: {
            showMinimizedCertificates () {
                this.showCertificates = true
            },
            hideMinimizedCertificates () {
                this.showCertificates = false
            }
        }
    }
</script>

<style lang="scss" scoped>
.course-item-vertical {
    font-size: 1.4rem;

    &__details {
        display: inline;
        padding: 0 15px 10px 0;
        gap: 15px;
        position: relative;
        margin-top: auto;
    }

    &__label {
        font-family: PlusJakartaSans-Bold, sans-serif;
        padding: 0 3px 0 0;
    }

    &__categories,
    &__level {
        font-family: PlusJakartaSans-Medium, sans-serif;
        font-size: 1.4rem;
        word-break: break-word;
        gap: 10px;
        margin: 0 10px 0 0;

        [class*="mobile"] & {
            gap: 5px;
        }
    }

    &__categories-names {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.4rem;
        margin: 0 4px 0 0;
    }

    &__coursetest {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.4rem;
    }

    &__all-badges {
        position: absolute;
        background: $alabaster;
        bottom: 60px;
        left: 400px;
        padding: 5px 20px;
        border-radius: 3px;
    }

    .icon-file-check {
        font-family: icomoon;
        font-size: 1.8rem;
        margin: 0 6px 0 0;
    }
}
</style>
